import translateAADAT from './AADAT';
import translateALIST from './ALIST';
import anyitNiceUrl from './ANYIT-nice-url';
import translateANYIT from './ANYIT';
import translateAKEDV from './AKEDV';
import translateFORM from './FORM';
import translateAMEKE from './AMEKE';
import translateAPROF from './APROF';
import translateSTATIC from './STATIC';

let englishLanguage = {
	AADAT : translateAADAT,
	ALIST : translateALIST,
	anyitNiceUrl: anyitNiceUrl,
	AKEDV: translateAKEDV,
	ANYIT: translateANYIT,
	FORM: translateFORM,
	AMEKE: translateAMEKE,
	APROF: translateAPROF,
	STATIC: translateSTATIC
};

export default englishLanguage;
